import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h3, reverseLinkUnderline, subheading } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    ${baseGrid};

    @media print {
      padding: 50px 0;
    }
  }
`;
export const centralColumns = css `
  @media ${from(Device.TabletLarge)} {
    grid-column: 2 / -2;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 3 / -3;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-column: 4 / -4;
  }
`;
const HeadingContainer = styled.div `
  grid-column: 1 / -1;

  ${Container}[data-layout='default'] &,
  ${Container}[data-layout='central'] & {
    ${centralColumns};
  }

  ${Container}[data-layout='split'] & {
    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 4;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 1 / span 5;
    }
  }

  ${Container}[data-layout='central'] & {
    text-align: center;
  }
`;
const SubHeading = styled.span `
  ${subheading};

  margin-bottom: ${fluid(8, 12)};
`;
const Heading = styled.h2 `
  ${h3};
`;
const ContentContainer = styled.div `
  grid-column: 1 / -1;

  ${Container}[data-layout='default'] &,
  ${Container}[data-layout='central'] & {
    ${centralColumns};

    ${() => CtasContainer} {
      margin-top: ${fluid(32, 34)};
    }
  }

  ${Container}[data-layout='central'] & {
    text-align: center;
  }

  ${Container}[data-layout='split'] & {
    @media ${from(Device.TabletLarge)} {
      grid-column: 5 / -1;
    }

    @media ${from(Device.DesktopSmall)} {
      grid-column: 6 / -1;
    }

    @media ${from(Device.DesktopLarge)} {
      grid-column: 7 / -1;
    }

    ${() => CtasContainer} {
      margin-top: ${fluid(32, 46)};
    }
  }
`;
const Content = styled.div `
  ${contentStyles};

  > p,
  > ul > li,
  > ol > li,
  blockquote {
    &:not(
        .large,
        .small,
        .x-small,
        .subheading,
        .h1-styles,
        .h2-styles,
        .h3-styles,
        .h4-styles,
        .h5-styles,
        .h6-styles
      ) {
      font-size: ${fluid(15, 24)};
      line-height: ${fluid(23, 35)};
    }
  }

  a,
  p a {
    ${reverseLinkUnderline};
    display: inline;
    scroll-margin: calc(var(--headerHeight, 0px) + 50px) 0 0;
  }

  > ol,
  > ul {
    margin-left: ${fluid(16, 24)};
  }

  @media print {
    blockquote {
      &:before {
        content: '“';
        font-size: 64px;
        line-height: 70px;
        background-image: none;
        margin-bottom: 0;
      }
    }
  }
`;
const CtasContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 10px ${fluid(10, 20)};
`;
const RichTextStyles = {
    Container,
    Content,
    ContentContainer,
    Heading,
    SubHeading,
    HeadingContainer,
    CtasContainer,
};
export default RichTextStyles;
